module.exports = __webpack_public_path__ + "media/images/conference-5-e09deacdc75ad526f3d55d978984ab8f.jpg";